<template>
  <Transition> <ScrollToTopBtn v-show="scrollBtn"></ScrollToTopBtn></Transition>
  <HeaderMobile v-if="viewStore.isMobile"></HeaderMobile>
  <Header v-else></Header>
  <HoerbuchIntro></HoerbuchIntro>
  <Gallery></Gallery>
  <Offers></Offers>
  <Promise></Promise>
  <CompetenceHoerbuchMobile
    v-if="viewStore.isMobile"
  ></CompetenceHoerbuchMobile>
  <CompetenceHoerbuch v-if="!viewStore.isMobile"></CompetenceHoerbuch>
  <HoerbuchRef></HoerbuchRef>
  <FAQ></FAQ>
  <Footer></Footer>
</template>

<script setup lang="ts">
import { useViewStore } from "~/stores/ViewStore";

const viewStore = useViewStore();
const isMobile = ref();
const scrollBtn = ref(false);

useHead({
  title: "Hörbuch & Hörspiel",
  meta: [
    {
      name: "description",
      content:
        "Unser Service bietet ganzheitliche Unterstützung für die Hörspiel sowie Hörbuch Produktion, inklusive Tonstudio, Postproduktion und Vermarktung. Darüber hinaus unterstützen wir bei der Suche nach professionellen Sprechern, stellen ein hochwertiges Tonstudio für herausragende Soundqualität bereit und kümmern uns um jeden Produktionsschritt für das perfekte Hörbuch oder Hörspiel.",
    },
  ],
});

onMounted(() => {
  window.scrollTo(0, 0);

  if (window.innerWidth < 992) {
    isMobile.value = true;
  }

  window.onscroll = function () {
    scrollFunction();
  };

  function scrollFunction() {
    if (
      document.body.scrollTop > 100 ||
      document.documentElement.scrollTop > 100
    ) {
      scrollBtn.value = true;
    } else {
      scrollBtn.value = false;
    }
  }
});
</script>

<style></style>
